import { render, staticRenderFns } from "./MedicalJournal.vue?vue&type=template&id=ba848038&scoped=true&"
import script from "./MedicalJournal.vue?vue&type=script&lang=js&"
export * from "./MedicalJournal.vue?vue&type=script&lang=js&"
import style0 from "./MedicalJournal.vue?vue&type=style&index=0&id=ba848038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba848038",
  null
  
)

export default component.exports